module.exports = __webpack_public_path__ + "static/media/Curoflow_telemedicine_software_for_doctors.62a0caee.webp";